import type { QueryFunctionContext } from '@tanstack/react-query';
import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';
import { NOTE_FRAGMENT } from './note-fragment';

type QueryContext = QueryFunctionContext<[string, string | undefined]>;

export const queryFn = async (
  { queryKey: [_, userId] }: QueryContext,
  limit = 5
) => {
  if (typeof userId === 'undefined') {
    return Promise.reject(new Error('User ID must be provided'));
  }
  const response = await gqlClient.request(
    gql(
      `
      query getUserNotes($limit: Float) {
        Notes(size: $limit) {
          ...NoteFields
        }
      }
    `,
      [NOTE_FRAGMENT]
    ),
    { limit }
  );

  if ('Notes' in response) {
    return response.Notes;
  }

  return [];
};
